import { useState, useEffect } from 'react';

var isSupported = undefined;

function useNativeLazyLoading() {
  var _useState = useState(isSupported),
      supported = _useState[0],
      setSupported = _useState[1];

  useEffect(function () {
    if (isSupported === undefined) {
      // Cache the value so it's ready for the initial render the next time the hook is used
      isSupported = 'loading' in HTMLImageElement.prototype;
    }

    setSupported(isSupported);

    if (process.env.NODE_ENV === 'test') {
      // If running in a test env, make sure to clean the value between runs
      isSupported = undefined;
    }
  }, []);
  return supported;
}

export default useNativeLazyLoading;
